






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import SpaModal from '@/components/molecules/Modal.vue'

@Component({
  components: {
    SpaModal,
  },
})
export default class AboutCaratDialog extends Vue {
  @Prop({ default: false })
  withHeader: boolean

  onClose(event) {
    this.$emit('close', event)
  }
}
